module.exports = __webpack_public_path__ + "static/im-armor-bc9e37c8edc4f049050ed07c40d7acb9.svg";